import BaseTable from './BaseTable';


class RestaurantTable extends BaseTable {

}

export default RestaurantTable;
